import React, { useCallback, useState } from 'react';

import { OverlayPortalSlot } from '../../molecules/ContentOverlay/ContentOverlay';
import { Blurrable } from '../../atoms/Blurrable/Blurrable';
import { TLPageWrapper } from '../../atoms/TLPageWrapper/TLPageWrapper';

import { useUrlQuery } from '../UrlQueryProvider/UrlQueryProvider';
import { OverlayContext } from './OverlayContext';

type Props = {
  children: React.ReactNode;
};

export const OverlayProvider: React.FC<Props> = ({ children }) => {
  const { isIframe } = useUrlQuery();
  const [openAmount, setOpenAmount] = useState<number>(0);

  const openOverlay = useCallback(() => {
    setOpenAmount((oldAmount: number) => oldAmount + 1);
  }, []);

  const closeOverlay = useCallback(() => {
    setOpenAmount((oldAmount: number) => oldAmount - 1);
  }, []);

  const hasOverlay = openAmount > 0;

  const contextValue = {
    hasOverlay,
    openOverlay,
    closeOverlay,
  };

  const isRedirectMode = !isIframe;

  return (
    <OverlayContext.Provider value={contextValue}>
      <TLPageWrapper zIndex={1} isRedirectMode={isRedirectMode}>
        <Blurrable blur={hasOverlay}>{children}</Blurrable>
      </TLPageWrapper>
      <OverlayPortalSlot isRedirectMode={isRedirectMode} />
    </OverlayContext.Provider>
  );
};
